import debug from 'debug';
import { getUserId } from 'sdi/app';
import { icon } from 'sdi/components/button';
import { DIV, INPUT, H1, H2 } from 'sdi/components/elements';
import { renderCheckbox } from 'sdi/components/input';
import tr, { formatNumber, fromRecord, Translated } from 'sdi/locale';
import { markdown } from 'sdi/ports/marked';
import { Category } from 'sdi/source';
import { notEmpty } from 'sdi/util';
import {
    getMapsInCategory,
    getMode,
    getSelectedCategories,
    getVisibleCategories,
} from 'view/src/queries/mapnavigator';
import {
    filterMapsWithPat,
    toggleHomeMode,
    removeFilterMapsCat,
    addFilterMapsCat,
} from '../../events/mapnavigator';
import { renderSwitchToTableButton, renderSwitchToTileButton } from '../button';

const logger = debug('sdi:sidebar');

const searchInput = () =>
    INPUT({
        key: 'map-navigator-search-input',
        type: 'search',
        name: 'search',
        placeholder: tr.view('searchAtlas'),
        onChange: e => filterMapsWithPat(e.currentTarget.value.trim()),
    });

const searchButton = () => icon('search');

// const clearCategorySelection = makeLabelAndIcon('clear', 3, 'times', () =>
//     tr.core('unselect')
// );

const searchField = () => DIV('input-wrapper', searchInput(), searchButton());

const isSelectedCategory = (catId: string) =>
    getSelectedCategories().indexOf(catId) >= 0;
// const isSelectedRole = (roleId: string) => getSelectedRole() == roleId;

const isSelectedCatClass = (catId: string) =>
    isSelectedCategory(catId) ? 'selected' : 'unselected';
// const isSelectedRoleClass = (fcatId: string) =>
//     isSelectedRole(fcatId) ? 'selected' : 'unselected';

const catCheckBox = (c: Category) =>
    renderCheckbox(
        'categories',
        () =>
            `${fromRecord(c.name)} (${formatNumber(
                getMapsInCategory(c.id).length,
            )})` as Translated,
        b => (b ? addFilterMapsCat(c.id) : removeFilterMapsCat(c.id)),
    );

const renderCategoryList = (cats: Category[] | readonly Category[]) =>
    cats.map(c => {
        return catCheckBox(c)(
            isSelectedCategory(c.id),
            isSelectedCatClass(c.id),
        );
    });

// const renderRoleList = (roles: Category[] | readonly Category[]) =>
//     DIV(
//         'role-list',
//         ...roles.map((fcat, i) =>
//             DIV(
//                 {
//                     className: `role-picker color-${i} ${isSelectedRoleClass(
//                         fcat.id
//                     )}`,
//                     onClick: () => {
//                         !isSelectedRole(fcat.id)
//                             ? selectFilterMapsRole(fcat.id)
//                             : clearFilterMapsRole();
//                     },
//                 },
//                 DIV(`role-legend color-${i}`),
//                 DIV('label', fromRecord(fcat.name))
//             )
//         )
//     );

const renderSwitch = () =>
    DIV(
        'sidebar-switch',
        getUserId().map(() =>
            getMode() === 'tile'
                ? renderSwitchToTableButton(toggleHomeMode)
                : renderSwitchToTileButton(toggleHomeMode),
        ),
    );

export const renderSidebar = () =>
    DIV(
        'sidebar',
        H1('pitch', markdown(tr.view('pitchAtlas'))),
        H2('pitch sub-pitch', markdown(tr.view('subPitchAtlas'))),
        searchField(),
        DIV(
            'category__wrapper',
            // notEmpty(getVisibleRoles()).map(fcats =>
            //     DIV('', H2('', tr.view('roleFilter')), renderRoleList(fcats))
            // ),
            notEmpty(getVisibleCategories()).map(bcats =>
                DIV(
                    '',
                    H2('', tr.view('filterByCategory')),
                    renderCategoryList(bcats),
                ),
            ),
        ),
        renderSwitch(),
        DIV('sidebar-footer', markdown(tr.view('dataAccess'))),
    );

export default renderSidebar;

logger('loaded');
